<template>
  <div class="head_wrap">
    <div class="head">
      <div class="logo" @click="checkTab(tabs[0])">
        <img src="../assets/imgs/official_logo.png" alt="" />
      </div>
      <div class="tabs">
          <div
            class="tab"
            v-for="(item, index) of tabs"
            :key="index"
            :class="[item.checked ? 'active' : '']"
            @click="checkTab(item)"
          >
            {{ item.lable }}
          </div>
        </div>
      <div class="right_data">
        <div class="connection">
          <img
            src="../assets/imgs/phone_logo.png"
            alt=""
          />&nbsp;+86-21-6427&nbsp;6820
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { ref } from "@vue/reactivity";
import { isNavigationFailure, useRouter } from "vue-router";
import { onMounted } from '@vue/runtime-core';
import { view } from '@/api/http';
export default {
  setup() {
    const tabs: any = ref<any>([
      {
        lable: "首页",
        router: "/",
        checked: true,
      },
      // {
      //   lable: "免费报告",
      //   router: "/report",
      //   checked: false,
      // },
      {
        lable: "联系我们",
        router: "/connect",
        checked: false,
      },
      {
        lable: "加入我们",
        router: "/join",
        checked: false,
      },
      {
        lable: "关于我们",
        router: "/about",
        checked: false,
      },
    ]);
    const router = useRouter();
    router.afterEach((to, from, failure) => {
      tabs.value.forEach((tab: any) => {
        const path = to.path.replace(/joinDetail/g, "join");
        tab.checked = path === tab.router;
      });
      if (isNavigationFailure(failure)) {
        console.log("failed navigation", failure);
      }
    });
    const checkTab = (checkedTab: any) => {
      router.push(checkedTab.router);
    };
    onMounted(()=>{
      view()
    })
    return {
      tabs,
      checkTab,
    };
  },
};
</script>
<style scoped lang="less">
.head_wrap {
  background: #fff;
  width: 100vw;
  position: fixed;
  top: 0;
  left: 0;
  height: 72px;
  z-index: 2;
  box-shadow: 0 0 1px 1px #e9e9e9 inset;
  .head {
    max-width: 1200px;
    margin: 0 auto;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    .logo {
      width: 220px;
      cursor: pointer;
      img {
        width: 100%;
      }
    }
    .tabs {
        display: inline-flex;
        align-items: center;
        margin-left: 24px;
        .tab {
          margin: 0 20px;
          padding: 0 3px;
          font-size: 16px;
          font-weight: bold;
          cursor: pointer;
          height: 72px;
          line-height: 72px;
          color: #596675;
          white-space: nowrap;
        }
        .tab.active,
        .tab:hover {
          color: #0072bd;
          border-bottom: 3px solid #0072bd;
          height: 69px;
        }
      }
    .right_data {
      margin-left: auto;
      .connection {
        display: inline-flex;
        align-items: center;
        img {
          width: 16px;
        }
      }
    }
  }
}
</style>
